export default __webpack_public_path__ + "static/media/card-financial.ea3ef2ad.png";